import toPropertyKey from './toPropertyKey'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defineProperty = (e: any, r: any, t: any): any => {
  return (
    (r = toPropertyKey(r)) in e
      ? Object.defineProperty(e, r, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        })
      : (e[r] = t),
    e
  )
}

export default defineProperty
